export default "__VITE_ASSET__DEpWegkt__"